import * as Yup from "yup";

import { BillingRunStatus } from "constants/billingRuns";
import { SaleType } from "constants/sale";

export function getValidationSchema({
  ruleBooksById = {},
  saleSubTypeId,
  saleType,
} = {}) {
  return Yup.object().shape({
    billingSettingsId: Yup.string().required("Required!"),
    exportedAtDateTime: Yup.date().nullable(),
    livestockSaleIds: Yup.array()
      .of(Yup.number())
      .min(1, "Required!")
      .required("Required!"),
    name: Yup.string().required("Required!"),
    ruleBookId: Yup.string()
      .nullable()
      .test(
        "matches-sale-sub-type",
        "This Rule Book is not set up for this Sale's Sale Sub Type.",
        value => {
          // Only Clearing Sales require the rule book to match the sale's sub type.
          const isClearingSale = saleType === SaleType.CLEARING;
          if (!isClearingSale || !value || !saleSubTypeId) {
            return true;
          }
          const ruleBook = ruleBooksById[value];
          if (!ruleBook) {
            return true;
          }
          return ruleBook.sale_sub_type_ids.includes(saleSubTypeId);
        },
      ),
    buyerPaysVendor: Yup.boolean(),
    status: Yup.string()
      .oneOf(Object.values(BillingRunStatus))
      .required("Required!"),
  });
}
